import { render, staticRenderFns } from "./WeeklyProgressPanel.vue?vue&type=template&id=3f8297f0&scoped=true&"
import script from "./WeeklyProgressPanel.vue?vue&type=script&lang=js&"
export * from "./WeeklyProgressPanel.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyProgressPanel.vue?vue&type=style&index=0&id=3f8297f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8297f0",
  null
  
)

/* custom blocks */
import block0 from "./WeeklyProgressPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports